import React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import Section from 'main/components/common/Section'
import { palette, spacing, Text, Title } from 'main/ui'
import { useTranslation } from 'react-i18next'

import { i18nKeyPrefix as PRE } from 'main/pages/Dashboard/pages/PaymentSettings/common'
import BankLink from '../BankLink'
import CardForm from '../CardForm'
import ToggleableLink from '../ToggleableLink/ToggleableLink'
import { Mode } from '../types'

interface IProps {
  mode: Mode
  close: () => void
}

export default function ChoiceSections(props: IProps) {
  const { mode, close } = props
  const [cardFormOpen, setCardFormOpen] = React.useState(false)
  const { t, i18n } = useTranslation(LOCIZE_NAMESPACE)

  const content = React.useMemo(() => {
    const bankAccountSection = {
      title: t(`${PRE}-PERSONAL-BANK-ACCOUNT-TITLE`),
      link: t(`${PRE}-PERSONAL-BANK-ACCOUNT-LINK`),
    }
    const creditCardSection = {
      title: t(`${PRE}-CREDIT-CARD-TITLE`),
      link: t(`${PRE}-CREDIT-CARD-LINK`),
    }
    return {
      bankAccountSection,
      creditCardSection,
    }
  }, [i18n.resolvedLanguage])

  return (
    <>
      <Section>
        <Title kind="section">{content.bankAccountSection.title}</Title>
        <div css={{ margin: `${spacing.majorScale(1)}px 0` }}>
          <Text css={{ color: palette.slate }}>{bankAccountDescription(mode)}</Text>
        </div>
        <div css={{ marginTop: `${spacing.majorScale(1)}px` }}>
          <BankLink onComplete={close}>{content.bankAccountSection.link}</BankLink>
        </div>
      </Section>

      <Section>
        <Title kind="section">{content.creditCardSection.title}</Title>
        <div css={{ margin: `${spacing.majorScale(1)}px 0` }}>
          <Text css={{ color: palette.slate }}>{cardDescription(mode)}</Text>
        </div>
        <ToggleableLink open={cardFormOpen} onChange={setCardFormOpen}>
          {content.creditCardSection.link}
        </ToggleableLink>
        {cardFormOpen && (
          <div css={{ marginTop: spacing.majorScale(1) }}>
            <CardForm
              onComplete={() => {
                setCardFormOpen(false)
                close()
              }}
            />
          </div>
        )}
      </Section>
    </>
  )
}

function bankAccountDescription(mode: Mode) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const errorMessage = t(`${PRE}-ERROR-UNSUPPORTED-MODE`)
  switch (mode) {
    case 'director':
      return t(`${PRE}-PERSONAL-BANK-ACCOUNT-DIRECTOR-DESCRIPTION`)
    case 'parent':
      return t(`${PRE}-PERSONAL-BANK-ACCOUNT-PARENT-DESCRIPTION`)
    default:
      throw new Error(`${errorMessage}: ${mode}`)
  }
}

function cardDescription(mode: Mode) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const errorMessage = t(`${PRE}-ERROR-UNSUPPORTED-MODE`)
  switch (mode) {
    case 'director':
      return t(`${PRE}-CREDIT-CARD-DIRECTOR-DESCRIPTION`)
    case 'parent':
      return t(`${PRE}-CREDIT-CARD-PARENT-DESCRIPTION`)
    default:
      throw new Error(`${errorMessage}: ${mode}`)
  }
}
